import { useTranslation } from 'react-i18next';
import type { FlatfinderData, FlatfinderPerspective } from 'realitiq-utils/src/flatfinder';
import { Modal } from '@/components/modals/new/modal';
import { FlatfinderViewer } from './viewer';

export function FlatfinderPreviewModal({
  data,
  open,
  perspectives,
  onDismiss,
}: {
  data: FlatfinderData;
  open: boolean;
  perspectives: FlatfinderPerspective[];
  onDismiss: () => void;
}) {
  const { t } = useTranslation();
  if (!open) return null;

  return (
    <Modal
      isOpen
      open={() => {}}
      dismiss={onDismiss}
      title={t('preview')}
      className="flex h-[calc(100dvh-2rem)] max-h-[calc(100dvh-2rem)] w-[calc(100%-2rem)] max-w-none flex-col overflow-hidden rounded-lg border border-primary-light/20 p-0 shadow-lg"
    >
      <Modal.Body
        autoFocus
        tabIndex={-1}
        className="min-h-0 flex-1 overflow-y-auto p-0 outline-none sm:p-0"
      >
        <FlatfinderViewer data={{ ...data, perspectives }} authenticatedPreview />
      </Modal.Body>
    </Modal>
  );
}
